<div class="client-details-container w-full h-full">
  <div class="header flex flex-row justify-between items-center">
    <div class="page-label">
      Organization Information
    </div>
    <div
      class="action-section flex flex-row justify-between items-center gap-[2rem]">
      <div
        *ngIf="profile?.role===roles.superAdmin && !clientId"
        class="flex w-full justify-end"
      >
        <app-primary-button
          (handleClick)="form.dirty && save()"
          [isDisabled]="!form.dirty"
          [isLoading]="form.dirty && loading"
          class="save-btn w-[25rem]"
          type="small"
        >
          {{ saveButtonText }}
        </app-primary-button>
      </div>
      <div
        *ngIf="profile?.role===roles.superAdmin && clientId"
        class="flex w-full justify-end "
      >
        <app-primary-button
          (handleClick)="form.dirty && isEditable ? save() : edit()"
          *ngIf="selectedUserProfile?.role !== roles.clientAdmin"
          [isDisabled]="isEditable && !form.dirty"
          [isLoading]="form.dirty && loading"
          class="edit w-[15rem]"
          type="small"
        >
          {{ isEditable ? 'Save' : 'Edit' }}
        </app-primary-button>
      </div>
      <div
        *ngIf="profile?.role===roles.superAdmin && clientId"
        class="flex w-full justify-end "
      >
        <app-icon
          (click)="delete()"
          *ngIf="selectedUserProfile?.role !== roles.clientAdmin"
          class="icon cursor-pointer"
          svgIcon="delete"
        >
        </app-icon>
      </div>
    </div>

  </div>

  <hr class="line mt-[0.8rem]">
  <form class="form flex flex-col w-full justify-center items-center lg:pl-[10rem] lg:pr-[10rem] xs:p-0 sm:p-0 md:p-0">
    <div class="row flex md:flex-row w-full md:space-x-[2rem] xs:flex-col sm:flex-col xs:space-x-0 sm:space-x-0">
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['clientName']"
        [maxLength]="validation.client.name.length.max"
        [parentFormGroup]="form"
        class="input md:w-[50%] xs:w-full sm:w-full"
        controlName="clientName"
        label="Organization Name"
        placeholder="Organization Name"
        type="small"
      ></app-text-input>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['clientStatus']"
        [options]="clientStatusOptions"
        [parentFormGroup]="form"
        class="input md:w-[25%] min-w-[25%] xs:w-full sm:w-1/2"
        controlName="clientStatus"
        label="Organization Status"
        placeholder="Select one"
        type="small"
      />
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableMultiple]="true"
        [error]="errorMessages['organizationType']"
        [options]="organizationTypeOptions"
        [parentFormGroup]="form"
        class="input md:w-[25%] min-w-[25%] xs:w-full sm:w-1/2"
        controlName="organizationType"
        label="Organization Type"
        placeholder="Select one"
        type="small"
      />
    </div>
    <div class="row flex md:flex-row w-full md:space-x-[2rem] xs:flex-col xs:space-x-0 sm:flex-col sm:space-x-0">
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['addressLine1']"
        [maxLength]="validation.address.addressLine1.length.max"
        [parentFormGroup]="form"
        class="input md:w-[50%] xs:w-full sm:w-full"
        controlName="addressLine1"
        label="Address"
        placeholder="Address"
        showCharCount="true"
        type="small"
      ></app-text-input>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['city']"
        [maxLength]="validation.address.city.length.max"
        [parentFormGroup]="form"
        class="input md:w-[20%] xs:w-full sm:w-1/2"
        controlName="city"
        label="City"
        placeholder="City"
        type="small"
      ></app-text-input>
      <div
        class="flex md:flex-row md:w-[30%] md:space-x-[2rem] xs:w-full sm:w-full xs:flex-row xs:space-x-[1.5rem] sm:flex-row sm:space-x-[1.5rem]">
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['state']"
          [options]="statesOptions"
          [parentFormGroup]="form"
          class="input md:w-1/2 xs:w-1/2 sm:w-1/2"
          controlName="state"
          label="State"
          placeholder="--"
          type="small"
        />
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['zipCode']"
          [maxLength]="validation.address.zipCode.length.max"
          [parentFormGroup]="form"
          class="input md:w-1/2 xs:w-1/2 sm:w-1/2"
          controlName="zipCode"
          label="Zip Code"
          placeholder="00000"
          type="small"
          [keepAsString]="true"
        ></app-number-input>
      </div>
    </div>
    <div class="row flex flex-col md:flex-row w-full md:space-x-[2rem]">
      <app-phone-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['phoneNumber']"
        [maxLength]="validation.phoneNumber.length.max"
        [parentFormGroup]="form"
        class="input lg:w-[25%] xs:w-full sm:w-[55%] md:w-[30%]"
        controlName="phoneNumber"
        label="Phone Number"
        placeholder="123 - 678 - 7890"
        type="small"
      ></app-phone-number-input>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['email']"
        [maxLength]="validation.email.length.max"
        [parentFormGroup]="form"
        class="input lg:w-[41%] xs:w-full sm:w-[70%] md:w-[36%]"
        controlName="email"
        label="Email"
        placeholder="user@mail.com"
        type="small"
      ></app-text-input>
      <div
        class="lg:w-[39%] xs:w-[80%] sm:w-[30%] md:w-[36%] mb-[1.3rem]"
      >
        <div
          class="label mb-[0.5rem]"
        >
          Use HEALTHY Mail Client?
        </div>
        <app-toggle-button
          (handleToggle)="userRole == roles.superAdmin ? toggleButtonClicked($event) : ''"
          [disable]="!isEditable || userRole !== roles.superAdmin || loading"
          [selectedValue]="form.controls.useSystemMailClient.value"
          class="toggle-button xs:mb-[1.5rem]"
          labelFalse="No"
          labelTrue="Yes"
        ></app-toggle-button>
      </div>

    </div>

    <div
      *ngIf="userRole === roles.superAdmin"
      class="row flex w-full"
    >
      <app-text-area-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['notes']"
        [maxLength]="validation.notes.length.max"
        [parentFormGroup]="form"
        class="text-area w-full h-full xs:w-full sm:w-full"
        controlName="notes"
        label="Stanford Internal Notes"
        placeholder="Stanford Internal Notes"
        showCharCount="true"
        type="small"
      ></app-text-area-input>
    </div>
  </form>
  <hr class="line mt-[1.5rem] mb-[1.5rem]">
</div>
